import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import getTrustPilotLogo from 'Helpers/Image/TrustPilotLogo';

import 'Components/Carousel/ProductMediaCarousel/TrustPilotBanner.scss';

export default function TrustPilotBanner() {
  const trustpilot = useSelector(state => state.trustpilot);
  const totalReviews = get(trustpilot, 'total', 0);
  const trustScore = get(trustpilot, 'score.trustScore', 0);
  const trustStars = get(trustpilot, 'score.stars', 0);

  return (
    <div className="TrustPilotBanner">
      <div className="TrustPilotBanner__score">
        <div className="TrustPilotBanner__score__small">
          <FormattedMessage
            id="trustpilot-banner.score.out-of"
            defaultMessage="{score} out of 5"
            values={{
              score: trustScore,
            }}
          />
        </div>
        <div className="TrustPilotBanner__score__large">
          {(trustStars === 4.5 || trustStars === 5) &&
            <>
              '<FormattedMessage id="trustpilot-banner.score.excellent" defaultMessage="Excellent" />'
            </>
          }
          {(trustStars === 4) &&
            <>
              '<FormattedMessage id="trustpilot-banner.score.great" defaultMessage="Great" />'
            </>
          }
          {(trustStars === 3 || trustStars === 3.5) &&
            <>
              '<FormattedMessage id="trustpilot-banner.score.average" defaultMessage="Average" />'
            </>
          }
          {(trustStars === 2 || trustStars === 2.5) &&
            <>
              '<FormattedMessage id="trustpilot-banner.score.poor" defaultMessage="Poor" />'
            </>
          }
          {(trustStars === 1 || trustStars === 1.5) &&
            <>
              '<FormattedMessage id="trustpilot-banner.score.bad" defaultMessage="Bad" />'
            </>
          }
        </div>
      </div>

      <div className="TrustPilotBanner__logo">
        <a
          href="https://www.trustpilot.com/review/www.fanatical.com"
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={-1}
        >
          <img
            className="trust-pilot-img"
            src={getTrustPilotLogo().image}
            alt={getTrustPilotLogo().alt}
          />
        </a>
      </div>

      <div className="TrustPilotBanner__reviews">
        <div className="TrustPilotBanner__reviews__small">
          <FormattedMessage id="trustpilot-banner.reviews.based-on" defaultMessage="Based on" />
        </div>
        <div className="TrustPilotBanner__reviews__large">
          <FormattedMessage
            id="trustpilot-banner.reviews.score"
            defaultMessage="{score} Reviews"
            values={{
              score: <FormattedNumber value={totalReviews} />,
            }}
          />
        </div>
      </div>
    </div>
  );
}
